/**
 * Shared editor-row types for CreateServiceDialog's type-specific forms
 * (KAN-157 split of the god-component). One file so CalculatorForm /
 * PricelistForm / ClassifierForm / QuestionnaireForm and the dialog itself
 * all agree on the same row shape instead of redeclaring it.
 */
import type { QuestionnaireFieldType } from '@/services/api/services';

export interface RequiredInputRow {
  name: string;
  unit: string;
  type: string;
}

export interface ConstantRow {
  name: string;
  value: string;
}

export interface PricingRow {
  name: string;
  variant: string;
  price: string;
  unit: string;
}

// One editable question row of a questionnaire service (TASK-332).
// `options` is kept as a comma-separated string while editing (same
// convention as the keywords field) and split into string[] on submit.
export interface QuestionRow {
  name: string;
  type: QuestionnaireFieldType;
  unit: string;
  description: string;
  required: boolean;
  options: string;
}

// Localized labels for the question-type select.
export const QUESTION_TYPE_OPTIONS: Array<{ value: QuestionnaireFieldType; label: string }> = [
  { value: 'number', label: 'Число' },
  { value: 'text', label: 'Текст' },
  { value: 'enum', label: 'Выбор' },
  { value: 'document', label: 'Документ' },
];
